import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import {
  createCustomer,
  loginCustomer,
  logOut,
} from "../../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import AccountWidget from "../../components/shared/AccountWidget";
import FlashMessage from "../../components/shared/FlashMessage";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import { Link } from "react-router-dom";
import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";

import styles from "../../thema/style";

class Account extends Component {
  render() {
    if (!this.props.customer.customer) {
      return (
        <Redirect
          to={{
            pathname: "/giris-yap",
            // state: { referrer: currentLocation }
          }}
        />
      );
    }

    const { customer } = this.props.customer;
    const isPremium = customer && customer.discount_enabled;

    return (
      <React.Fragment>
        <PageTitle title={"Hesabım"} />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9"} style={{ marginTop: 15 }}>
                <FlashMessage />

                {/* Modern Hoşgeldin Kartı */}
                <div
                  style={{
                    background: isPremium
                      ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                      : "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                    borderRadius: "15px",
                    padding: "30px",
                    marginBottom: "30px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    color: "white",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {/* Dekoratif Daireler */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-50px",
                      right: "-50px",
                      width: "150px",
                      height: "150px",
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.1)",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: "-30px",
                      left: "-30px",
                      width: "100px",
                      height: "100px",
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.08)",
                    }}
                  />

                  <h2
                    style={{
                      color: "white",
                      marginBottom: "10px",
                      fontSize: "28px",
                    }}
                  >
                    Hoş Geldiniz, {customer.full_name}!
                  </h2>

                  {isPremium && (
                    <div
                      style={{
                        display: "inline-block",
                        background: "rgba(255,255,255,0.2)",
                        padding: "8px 20px",
                        borderRadius: "25px",
                        marginTop: "10px",
                        backdropFilter: "blur(10px)",
                      }}
                    >
                      <FontAwesomeIcon
                        icon="crown"
                        style={{ color: "#ffd700", marginRight: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        Premium Müşteri
                      </span>
                      {customer.discount_type === "percentage" && (
                        <span style={{ marginLeft: "10px" }}>
                          %{customer.discount_value} İndirim
                        </span>
                      )}
                      {customer.discount_type === "fixed" && (
                        <span style={{ marginLeft: "10px" }}>
                          ₺{customer.discount_value} İndirim
                        </span>
                      )}
                    </div>
                  )}

                  <p
                    style={{
                      marginTop: "15px",
                      marginBottom: "0",
                      opacity: "0.95",
                      fontSize: "16px",
                    }}
                  >
                    Hesabınızdan siparişlerinizi takip edebilir, adres ve profil
                    bilgilerinizi güncelleyebilirsiniz.
                  </p>
                </div>

                {/* Modern Kartlar Grid */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                    gap: "20px",
                    marginTop: "30px",
                  }}
                >
                  {/* Siparişlerim Kartı */}
                  <Link
                    to={"/hesabim/siparislerim"}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        background: "white",
                        borderRadius: "12px",
                        padding: "25px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        border: "2px solid transparent",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 25px rgba(0,0,0,0.15)";
                        e.currentTarget.style.borderColor = "#667eea";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 15px rgba(0,0,0,0.08)";
                        e.currentTarget.style.borderColor = "transparent";
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "12px",
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "15px",
                        }}
                      >
                        <FontAwesomeIcon
                          icon="shopping-cart"
                          style={{ color: "white", fontSize: "24px" }}
                        />
                      </div>
                      <h4 style={{ color: "#333", marginBottom: "8px" }}>
                        Siparişlerim
                      </h4>
                      <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>
                        Tüm siparişlerinizi görüntüleyin
                      </p>
                    </div>
                  </Link>

                  {/* Adreslerim Kartı */}
                  <Link
                    to={"/hesabim/adreslerim"}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        background: "white",
                        borderRadius: "12px",
                        padding: "25px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        border: "2px solid transparent",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 25px rgba(0,0,0,0.15)";
                        e.currentTarget.style.borderColor = "#667eea";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 15px rgba(0,0,0,0.08)";
                        e.currentTarget.style.borderColor = "transparent";
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "12px",
                          background:
                            "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "15px",
                        }}
                      >
                        <FontAwesomeIcon
                          icon="map-marker-alt"
                          style={{ color: "white", fontSize: "24px" }}
                        />
                      </div>
                      <h4 style={{ color: "#333", marginBottom: "8px" }}>
                        Adreslerim
                      </h4>
                      <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>
                        Teslimat adreslerinizi yönetin
                      </p>
                    </div>
                  </Link>

                  {/* Profilim Kartı */}
                  <Link
                    to={"/hesabim/profilimi-duzenle"}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        background: "white",
                        borderRadius: "12px",
                        padding: "25px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        border: "2px solid transparent",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 25px rgba(0,0,0,0.15)";
                        e.currentTarget.style.borderColor = "#667eea";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 15px rgba(0,0,0,0.08)";
                        e.currentTarget.style.borderColor = "transparent";
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "12px",
                          background:
                            "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "15px",
                        }}
                      >
                        <FontAwesomeIcon
                          icon="user"
                          style={{ color: "white", fontSize: "24px" }}
                        />
                      </div>
                      <h4 style={{ color: "#333", marginBottom: "8px" }}>
                        Profilimi Düzenle
                      </h4>
                      <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>
                        Kişisel bilgilerinizi güncelleyin
                      </p>
                    </div>
                  </Link>

                  {/* Şifre Değiştir Kartı */}
                  <Link
                    to={"/hesabim/sifremi-guncelle"}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        background: "white",
                        borderRadius: "12px",
                        padding: "25px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        border: "2px solid transparent",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 25px rgba(0,0,0,0.15)";
                        e.currentTarget.style.borderColor = "#667eea";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 15px rgba(0,0,0,0.08)";
                        e.currentTarget.style.borderColor = "transparent";
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "12px",
                          background:
                            "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "15px",
                        }}
                      >
                        <FontAwesomeIcon
                          icon="lock"
                          style={{ color: "white", fontSize: "24px" }}
                        />
                      </div>
                      <h4 style={{ color: "#333", marginBottom: "8px" }}>
                        Şifremi Değiştir
                      </h4>
                      <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>
                        Hesap güvenliğinizi sağlayın
                      </p>
                    </div>
                  </Link>

                  {/* Sipariş Geçmişi Kartı */}
                  <Link
                    to={"/hesabim/siparis-gecmisim"}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        background: "white",
                        borderRadius: "12px",
                        padding: "25px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        border: "2px solid transparent",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 25px rgba(0,0,0,0.15)";
                        e.currentTarget.style.borderColor = "#667eea";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 15px rgba(0,0,0,0.08)";
                        e.currentTarget.style.borderColor = "transparent";
                      }}
                    >
                      <div
                        style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "12px",
                          background:
                            "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "15px",
                        }}
                      >
                        <FontAwesomeIcon
                          icon="history"
                          style={{ color: "white", fontSize: "24px" }}
                        />
                      </div>
                      <h4 style={{ color: "#333", marginBottom: "8px" }}>
                        Sipariş Geçmişim
                      </h4>
                      <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>
                        Geçmiş siparişlerinizi inceleyin
                      </p>
                    </div>
                  </Link>

                  {/* Çıkış Yap Kartı */}
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.logOut();
                    }}
                    style={{
                      background: "white",
                      borderRadius: "12px",
                      padding: "25px",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      border: "2px solid transparent",
                      height: "100%",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 25px rgba(0,0,0,0.15)";
                      e.currentTarget.style.borderColor = "#ff6b6b";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 15px rgba(0,0,0,0.08)";
                      e.currentTarget.style.borderColor = "transparent";
                    }}
                  >
                    <div
                      style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "12px",
                        background:
                          "linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "15px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon="sign-out-alt"
                        style={{ color: "white", fontSize: "24px" }}
                      />
                    </div>
                    <h4 style={{ color: "#333", marginBottom: "8px" }}>
                      Çıkış Yap
                    </h4>
                    <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>
                      Hesabınızdan güvenli çıkış
                    </p>
                  </div>
                </div>

                {/* Premium Müşteri Avantajları */}
                {isPremium && (
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
                      borderRadius: "15px",
                      padding: "25px",
                      marginTop: "30px",
                      marginBottom: "30px",
                      boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                    }}
                  >
                    <h3 style={{ color: "#333", marginBottom: "15px" }}>
                      <FontAwesomeIcon
                        icon="star"
                        style={{ color: "#ffd700", marginRight: "10px" }}
                      />
                      Premium Müşteri Avantajlarınız
                    </h3>
                    <ul
                      style={{
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <li
                        style={{
                          padding: "10px 0",
                          borderBottom: "1px solid rgba(255,255,255,0.3)",
                          color: "#555",
                        }}
                      >
                        <FontAwesomeIcon
                          icon="check-circle"
                          style={{ color: "#4caf50", marginRight: "10px" }}
                        />
                        {customer.discount_type === "percentage" ? (
                          <span>
                            <strong>%{customer.discount_value}</strong> oranında
                            özel indirim
                          </span>
                        ) : (
                          <span>
                            <strong>₺{customer.discount_value}</strong>{" "}
                            tutarında özel indirim
                          </span>
                        )}
                      </li>
                      <li
                        style={{
                          padding: "10px 0",
                          borderBottom: "1px solid rgba(255,255,255,0.3)",
                          color: "#555",
                        }}
                      >
                        <FontAwesomeIcon
                          icon="check-circle"
                          style={{ color: "#4caf50", marginRight: "10px" }}
                        />
                        Minimum sepet tutarı:{" "}
                        <strong>₺{customer.min_cart_amount}</strong>
                      </li>
                      <li
                        style={{
                          padding: "10px 0",
                          color: "#555",
                        }}
                      >
                        <FontAwesomeIcon
                          icon="check-circle"
                          style={{ color: "#4caf50", marginRight: "10px" }}
                        />
                        Özel kampanya ve fırsatlardan öncelikli haberdar olma
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              <div className={"col-md-3"}>
                <AccountWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { createCustomer, loginCustomer, logOut };

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/routers/Account/index.js